<template>
    <div>
        <b-modal
            id="m-approve-temuan"
            title="Approve Temuan Emas"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @show="init"
        >
            <b-row v-if="item">
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Kotor <span style="color: red;">*</span> <small class="text-muted">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.dry_weight"
                                step="0.01"
                                placeholder="Masukkan Berat Kotor"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Potongan <span style="color: red;">*</span> <small class="text-muted">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.final_weight_reduction"
                                step="0.01"
                                placeholder="Masukkan Berat Potongan"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="12" v-if="item.sm_purity">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kadar <span style="color: red;">*</span>
                        </template>
                        <b-form-input
                            v-model="input.final_purity"
                            step="0.01"
                            placeholder="Masukkan Kadar"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="12" v-if="isSupplierSource">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kategori SM <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.final_sm_category"
                            :allow-empty="true"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="Pilih Kategori SM"
                            :options="optCategorySM"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="12" v-if="isSupplierSource">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kategori Supplier <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.final_supplier_category"
                            :allow-empty="true"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="Pilih Kategori Supplier"
                            :options="optCategorySupplier"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Catatan <span style="color: red;">*</span>
                        </template>
                        <b-input-group>
                            <b-form-textarea
                                id="notes"
                                v-model="input.final_notes"
                                placeholder="Masukkan catatan"
                                rows="4"
                                maxlength="1000"
                            />
                        </b-input-group>
                        <small :class="notesCharCount > 1000 ? 'text-danger' : 'text-muted'">
                            {{ notesCharCount }} / 1000
                        </small>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr />
            <div class="text-right">
                <b-button
                    variant="secondary"
                    @click="$bvModal.hide('m-approve-temuan')"
                    class="mr-2"
                >
                    Batal
                </b-button>
                <b-button
                    variant="primary"
                    @click="approve"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan & Approve" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ModalApproveTemuan",
    props: {
        item: {
            type: Object,
            default: () => null
        },
        action: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            input: {
                final_purity: null,
                dry_weight: null,
                final_weight_reduction: null,
                final_sm_category: null,
                final_supplier_category: null,
                final_notes: null
            },
            isSubmitting: false,
            optCategorySM: [],
            optCategorySupplier: [],
        };
    },
    computed: {
        notesCharCount() {
            if (!this.input.final_notes) return 0;
            return this.input.final_notes.length;
        },
        isPEISource() {
            return !!(this.item && this.item.origin_item && this.item.origin_item.source === "PEI");
        },
        isSupplierSource() {
            return !!(this.item && this.item.variance && this.item.variance.is_supplier_source);
        },
        supplierSource() {
            return this.item && this.item.origin_item ? this.item.origin_item.source : null;
        },
    },
    watch: {
        item: {
            handler(newItem) {
                if (newItem) {
                    this.resetForm();
                    this.input.final_purity = newItem.sm_purity;
                    this.input.dry_weight = newItem.sm_dry_weight;
                    this.input.final_weight_reduction =
                        newItem.sm_weight_reduction;
                }
            },
            immediate: true
        }
    },
    methods: {
        resetForm() {
            this.input = {
                final_purity: null,
                dry_weight: null,
                final_weight_reduction: null,
                final_notes: null,
                final_sm_category: null,
                final_supplier_category: null,
            };
        },

        init() {
            this.getCategoryVariance();
        },

        async getCategoryVariance() {
            const supplierUrl = this.supplierSource
                ? `master/gold-variance-categories?for=SUPPLIER_FINAL&source=${this.supplierSource}`
                : "master/gold-variance-categories?for=SUPPLIER_FINAL";
            await Promise.all([
                this.$axios.get("master/gold-variance-categories?for=SM_FINAL")
                    .then(response => {
                        this.optCategorySM = response.data.data;
                    }),
                this.$axios.get(supplierUrl)
                    .then(response => {
                        this.optCategorySupplier = response.data.data;
                    })
            ]).catch(error => {
                this.$helper.parseError(this, error);
            });
        },

        async approve() {
            if (
                this.input.dry_weight === null ||
                this.input.dry_weight === ""
            ) {
                this.$helper.toastError(this, "Berat Kotor wajib diisi");
                return;
            }
            if (
                this.input.final_weight_reduction === null ||
                this.input.final_weight_reduction === ""
            ) {
                this.$helper.toastError(this, "Berat Potongan wajib diisi");
                return;
            }
            if (this.item.sm_purity) {
                if (
                    this.input.final_purity === null ||
                    this.input.final_purity === ""
                ) {
                    this.$helper.toastError(this, "Kadar wajib diisi");
                    return;
                }
            }

            if (!this.input.final_notes) {
                this.$helper.toastError(this, "Catatan wajib diisi");
                return;
            }

            if (this.notesCharCount > 1000) {
                this.$helper.toastError(this, "Catatan maksimal 1000 karakter");
                return;
            }

            if (this.isSupplierSource) {
                if (!this.input.final_sm_category) return this.$helper.toastError(this, "Kategori SM wajib diisi");
                if (!this.input.final_supplier_category) return this.$helper.toastError(this, "Kategori Supplier wajib diisi");
            }

            this.isSubmitting = true;

            try {
                let isConfirmed = confirm(
                    "Apakah Anda yakin akan menyetujui temuan ini?"
                );
                if (!isConfirmed) {
                    return;
                }

                const payload = {
                    action: this.action,
                    final_purity: this.input.final_purity,
                    final_dry_weight: parseFloat(this.input.dry_weight).toFixed(
                        2
                    ),
                    final_weight_reduction: parseFloat(
                        this.input.final_weight_reduction
                    ).toFixed(4),
                    final_notes: this.input.final_notes,
                    sm_category: this.input.final_sm_category ? this.input.final_sm_category.name : null,
                    supplier_category: this.input.final_supplier_category ? this.input.final_supplier_category.name : null
                };

                await this.$axios.post(
                    `gold-receipt-variances/${this.item.id}/approve`,
                    payload
                );

                this.$helper.toastSuccess(
                    this,
                    "Temuan emas berhasil di-approve"
                );
                this.$emit("refresh");
                this.$bvModal.hide("m-approve-temuan");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>
